export function $(el, scope){
  return (scope || document).querySelectorAll(el);
}

export function $1(el, scope){
  return (scope || document).querySelector(el);
}

export function closest(selector, el) {
  let elements = [...$(selector)];
  if ( ! elements.length ) return null;
  do {
    el = el.parentNode;
  } while ( elements.indexOf(el) < 0 );
  return el;
}



// WEBPACK FOOTER //
// ./scripts/Utilities/selector.js